import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import FormState from "@toolkit/Framework/Store/Toolkit/Components/Form/FormState";
import { FormModel } from "@toolkit/Framework/Store/Toolkit/Components/Form/FormTypes";
import { DestroyFormHandlerParameter } from "@toolkit/Framework/Store/Toolkit/Components/Form/Handlers/DestroyForm";
import { SetFormHandlerParameter } from "@toolkit/Framework/Store/Toolkit/Components/Form/Handlers/SetForm";
import { Draft } from "immer";

const initialState: FormState = {
    forms: [],
};

const actions = {
    "Toolkit/Components/Form/SetForm": (draft: Draft<FormState>, action: { parameter: SetFormHandlerParameter }) => {
        const newForm: FormModel = {
            hasAlreadyError: false,
            id: action.parameter.formId,
            inputs: [],
        };

        draft.forms = [...draft.forms, newForm];
    },
    "Toolkit/Components/Form/DestroyForm": (
        draft: Draft<FormState>,
        action: { parameter: DestroyFormHandlerParameter },
    ) => {
        const filteredFormsList = draft.forms.filter(x => x.id !== action.parameter.formId);
        draft.forms = filteredFormsList;
    },
    "Toolkit/Components/Form/SetInput": (draft: Draft<FormState>, action: { forms: FormModel[] }) => {
        draft.forms = action.forms;
    },
    "Toolkit/Components/Form/EmptyForm": (draft: Draft<FormState>, action: { forms: FormModel[] }) => {
        draft.forms = action.forms;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type FormActions = Parameters<typeof reducer>[1];
export default reducer;
